import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

type HypoMinimizerPumpingResumedReason =
  | "MAX_SUSPEND" // Resume due to Maximum Suspend Time Reached (1)
  | "USER_OVERRIDE"; // Resume due to Suspend-Override by the user (2)

export type HypoMinimizerResumePayload = {
  reason?: number;
};

export type HypoMinimizerResumeEvent = {
  reason?: HypoMinimizerPumpingResumedReason;
};

const hypoMinimizerResumeSchema = z.object({
  reason: cz.permissive(z.number()),
});

export const LID_HYPO_MINIMIZER_RESUME = {
  value: 0xc7,
  name: "Hypo Minimizer Resume",
  format: "i............",
  fields: ["reason"],
  postprocess: rec => ({
    reason: getHypoMinimizerResumeReason(rec.reason),
  }),
  schema: hypoMinimizerResumeSchema,
} as const satisfies TandemEventDefinition<HypoMinimizerResumePayload, HypoMinimizerResumeEvent>;

const getHypoMinimizerResumeReason = (reason?: number): HypoMinimizerPumpingResumedReason | undefined =>
  reason === 1 ? "MAX_SUSPEND" : reason === 2 ? "USER_OVERRIDE" : undefined;
